// extracted by mini-css-extract-plugin
module.exports = {"outer":"Expandable-module--outer--3-q10","open":"Expandable-module--open--1o5cq"};